import React from 'react';

const ArrowUpRightIcon = ({ fill = "#136395", width = "20", height = "20" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" style={{ marginRight: "2px" }}>
      <path d="M5.83325 14.1666L14.1666 5.83325M14.1666 5.83325H5.83325M14.1666 5.83325V14.1666" stroke={fill} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ArrowUpRightIcon;